import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy
} from '@angular/core';
import { SubscriberChannelModule } from '../../subscriber-channel.module';
import { BaseSubscriberChannelComponent } from '../../abstract-components/base-subscriber-channel.component';
import { PageEvent } from '@angular/material/paginator';
import { filter, tap } from 'rxjs';
import { EventService } from '~app/app/~shared/services/event.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { GlobalEvent } from '~core/models/shared.models';

@Component({
  selector: 'subscriber-channel-list-page',
  standalone: true,
  imports: [SubscriberChannelModule],
  templateUrl: './subscriber-channel-list-page.component.html',
  styleUrl: './subscriber-channel-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberChannelListPageComponent
  extends BaseSubscriberChannelComponent
  implements AfterContentInit, OnDestroy
{
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);

  resources$ = this._resourceFacade.resources$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;
  isLoading$ = this._resourceFacade.isLoading$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  ngAfterContentInit(): void {
    this._resourceFacade.getData();
  }

  ngOnDestroy(): void {
    this._resourceFacade.resetState();
  }

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }

  onSearch(searchText: string | null): void {
    this._resourceFacade.applyFilters({
      name: searchText ? `like(%${searchText}%)` : null
    });
    this._resourceFacade.getData({ refresh: true });
  }
}
